export var STORE_NAME;
(function (STORE_NAME) {
    // essential
    STORE_NAME["ACCESS_TOKEN"] = "access_token";
    STORE_NAME["ACCOUNTBOX"] = "accountbox";
    STORE_NAME["CID"] = "cid";
    STORE_NAME["COOKIE_CONSENT"] = "cookieConsent";
    STORE_NAME["GD"] = "gd";
    STORE_NAME["HOME_ESSENTIAL"] = "home-essential";
    STORE_NAME["JSESSIONID"] = "JSESSIONID";
    STORE_NAME["PHONITAIRE"] = "phonitaire";
    STORE_NAME["SHOP_WEB"] = "shop-web";
    STORE_NAME["SHOP_ESSENTIAL"] = "shop-essential";
    STORE_NAME["SESSION_HOST"] = "SESSION_HOST";
    STORE_NAME["USER"] = "user";
    // functional
    STORE_NAME["LOBBY"] = "lobby";
    STORE_NAME["SHOP"] = "shop";
})(STORE_NAME || (STORE_NAME = {}));
//# sourceMappingURL=STORE.js.map